// src/admin/AdminLiteDashboard.js
import React, { useState,useEffect } from 'react';
import {
    AppBar, Toolbar, Typography, Button, Drawer, List, ListItem, ListItemText, Box,
    CssBaseline, IconButton, Avatar, ListItemIcon, Divider, Collapse
} from '@mui/material';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import ImageIcon from '@mui/icons-material/Image';
import SchoolIcon from '@mui/icons-material/School';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CampaignIcon from '@mui/icons-material/Campaign';
import CollectionsIcon from '@mui/icons-material/Collections';
import PersonIcon from '@mui/icons-material/Person';

import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

/* import { QuestionAnswer } from '@mui/icons-material';
import { Search } from '@mui/icons-material'; */
import { Assignment } from '@mui/icons-material';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import avtr from '../assets/avatar.png';
import { GlobalStyles } from '@mui/system';
const drawerWidth = 240;

const AdminLiteDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false); // State to manage drawer open/close
    const [imagesOpen, setImagesOpen] = useState(false); // State for "Images" submenu
    const [adminName, setAdminName] = useState('');

    // Logout function
    const handleLogout = () => {
        navigate('/admin/login'); // Redirect to admin login page
    };

    // Toggle drawer function
    const toggleDrawer = () => {
        setOpen(!open);
    };
 // Toggle Images submenu
 const handleImagesClick = () => {
    setImagesOpen(!imagesOpen);
};
useEffect(() => {
    const storedName = sessionStorage.getItem('adminName');
    if (!storedName) {
        navigate('/admin/login'); // Redirect if no admin is logged in
    } else {
        setAdminName(storedName); // Set admin name
    }

    const checkInactivity = () => {
        const loginTime = parseInt(sessionStorage.getItem('adminLoginTime'), 10);
        const currentTime = Date.now();
        const timeout = 15 * 60 * 1000; // 15 minutes inactivity timeout

        if (currentTime - loginTime > timeout) {
            alert('You have been logged out due to inactivity.');
            sessionStorage.clear(); // Clear session storage
            navigate('/admin/login'); // Redirect to login
        }
    };

    const interval = setInterval(checkInactivity, 1000); // Check every second
    return () => clearInterval(interval); // Cleanup on component unmount
}, [navigate]);
    return (
        <Box  sx={{ display: 'flex' }}>
            <CssBaseline />
            <GlobalStyles styles={{
                html: { height: '100%', overflow: 'auto' },
                body: { height: '100%', overflow: 'auto' },
                '#root': { height: '100%', overflowY: 'auto' },
                '.dashboard-container': { height: '100%', overflowY: 'auto' },
            }} />

            {/* AppBar styled similar to AdminLTE top nav */}
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#343a40' }}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={toggleDrawer}
                        edge="start"
                        sx={{ mr: 2, display: { sm: 'none' } }} // Show only on mobile
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                        Admin Dashboard
                    </Typography>
                    <Button color="inherit" onClick={handleLogout}>
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            {/* Sidebar Drawer */}
            <Drawer
                variant="temporary" // Mobile drawer
                open={open}
                onClose={toggleDrawer}
                ModalProps={{ keepMounted: true }} // Better open performance on mobile
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', bgcolor: '#343a40', color: '#ffffff' },
                }}
            >
                <SidebarContent currentLocation={location} toggleDrawer={toggleDrawer} handleImagesClick={handleImagesClick}
    imagesOpen={imagesOpen} setImagesOpen={setImagesOpen} adminName={adminName}
 />
            </Drawer>

            {/* Permanent Sidebar for larger screens */}
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', bgcolor: '#343a40', color: '#ffffff' },
                }}
                open
            >
                <SidebarContent currentLocation={location} toggleDrawer={toggleDrawer}
    handleImagesClick={handleImagesClick}
    imagesOpen={imagesOpen} setImagesOpen={setImagesOpen} adminName={adminName} // Add this prop

 />
            </Drawer>

            {/* Main Content Area */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    bgcolor: '#f4f6f9', // AdminLTE main area background color
                    width: { xs: '100%', sm: `calc(100% - ${drawerWidth}px)` },
                    minHeight: '100vh',
                    
                    
                }}
            >
                <Toolbar />
                <Outlet /> {/* Render the respective component based on the route */}
            </Box>
        </Box>
    );
};

// Sidebar Content component
const SidebarContent = ({ currentLocation, toggleDrawer, handleImagesClick, imagesOpen, setImagesOpen,adminName }) => (
    <Box>
        <Toolbar />
        <Box sx={{ padding: 2, textAlign: 'center' }}>
            <Avatar alt="Admin" src={avtr} sx={{ width: 64, height: 64, marginBottom: 2 }} />
            <Typography variant="h6">Welcome, {adminName}</Typography>
            <Typography variant="body2" color="textSecondary">Administrator</Typography>
        </Box>
        <Divider sx={{ bgcolor: '#ffffff' }} />
        <List>
            <SidebarItem
                to="/admin/home"
                label="Dashboard"
                icon={<HomeIcon />}
                active={currentLocation.pathname === '/admin/home'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
         {/*    <SidebarItem
                to="/admin/carousel"
                label="Carousel Images"
                icon={<ImageIcon />}
                active={currentLocation.pathname === '/admin/carousel'}
            />
            <SidebarItem
                to="/admin/gallery"
                label="Gallery Images"
                icon={<ImageIcon />}
                active={currentLocation.pathname === '/admin/gallery'}
            /> */}
             <ListItem button onClick={handleImagesClick}>
                <ListItemIcon sx={{ color: currentLocation.pathname.includes('/admin') ? '#ffffff' : '#bdbdbd', minWidth: 40 }}><CollectionsIcon /></ListItemIcon>
                <ListItemText primary="Gallery" />
                {imagesOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={imagesOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <SidebarItem
                        to="/admin/carousel"
                        label="Carousel Images"
                        icon={<ImageIcon />}
                        active={currentLocation.pathname === '/admin/carousel'}
                        //onClick={toggleDrawer}
                        onClick={() => {
                            toggleDrawer();
                            setImagesOpen(false); // Close the submenu after click
                        }}
                    />
                    <SidebarItem
                        to="/admin/album"
                        label="Album"
                        icon={<ImageIcon />}
                        active={currentLocation.pathname === '/admin/album'}
                        //onClick={toggleDrawer}
                        onClick={() => {
                            toggleDrawer();
                            setImagesOpen(false); // Close the submenu after click
                        }}
                    />
                    <SidebarItem
                        to="/admin/gallery"
                        label="Gallery Images"
                        icon={<ImageIcon />}
                        active={currentLocation.pathname === '/admin/gallery'}
                        //onClick={toggleDrawer}
                        onClick={() => {
                            toggleDrawer();
                            setImagesOpen(false); // Close the submenu after click
                        }}
                    />
                    <SidebarItem
                to="/admin/video"
                label="Video"
                icon={<OndemandVideoIcon />}
                active={currentLocation.pathname === '/admin/video'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
                </List>
            </Collapse>
            {/* <SidebarItem
                to="/admin/video"
                label="Video"
                icon={<OndemandVideoIcon />}
                active={currentLocation.pathname === '/admin/video'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            /> */}
            <SidebarItem
                to="/admin/contact-detail"
                label="Footer Details"
                icon={<Assignment />}
                active={currentLocation.pathname === '/admin/contact-detail'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
            <SidebarItem
                to="/admin/courses"
                label="Courses"
                icon={<SchoolIcon />}
                active={currentLocation.pathname === '/admin/courses'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
             <SidebarItem
                to="/admin/notifications"
                label="Notification"
                icon={<NotificationsIcon />}
                active={currentLocation.pathname === '/admin/notifications'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
             <SidebarItem
                to="/admin/advirtise"
                label="Advirtise"
                icon={<CampaignIcon />}
                active={currentLocation.pathname === '/admin/advirtise'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
            {/* <SidebarItem
                to="/admin/album"
                label="Album"
                icon={<ImageIcon />}
                active={currentLocation.pathname === '/admin/album'}
            /> */}
            <SidebarItem
                to="/admin/inquiry"
                label="Inquiries"
                icon={<Assignment />}
                active={currentLocation.pathname === '/admin/inquiry'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
            <SidebarItem
                to="/admin/callback"
                label="Callback Numbers"
                icon={<PhoneCallbackIcon />}
                active={currentLocation.pathname === '/admin/callback'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
            <SidebarItem
                to="/admin/addstaff"
                label="Add Staff"
                icon={<PersonIcon />}
                active={currentLocation.pathname === '/admin/addstaff'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
            <SidebarItem
                to="/admin/register"
                label="Register Admin"
                icon={<PersonIcon />}
                active={currentLocation.pathname === '/admin/register'}
                //onClick={toggleDrawer}
                onClick={() => {
                    toggleDrawer();
                    setImagesOpen(false); // Close the submenu after click
                }}
            />
        </List>
    </Box>
);

// Sidebar Item Component for each menu item with active state styling
const SidebarItem = ({ to, label, icon, active, onClick }) => (
    <ListItem
        button
        component={Link}
        to={to}
        onClick={onClick}
        sx={{
            color: active ? '#ffffff' : '#bdbdbd',
            fontWeight: active ? 'bold' : 'normal',
            backgroundColor: active ? '#495057' : 'transparent',
            pl: active ? 3 : 2, // Adds left padding for active items
            borderLeft: active ? '4px solid #ffffff' : 'none', // Left border for active items
            '&:hover': {
                backgroundColor: '#495057',
                color: '#ffffff',
                borderLeft: '4px solid #ffffff',
            },
        }}
    >
        <ListItemIcon sx={{ color: active ? '#ffffff' : '#bdbdbd', minWidth: 40 }}>
            {icon}
        </ListItemIcon>
        <ListItemText primary={label} />
    </ListItem>
);

export default AdminLiteDashboard;
